var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitgroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e24848;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.97,17.35H2.243A.749.749,0,0,1,1.5,16.6V3.1a.749.749,0,0,1,.747-.75H8.97a.75.75,0,0,0,0-1.5H2.243A2.249,2.249,0,0,0,0,3.1V16.6a2.249,2.249,0,0,0,2.243,2.25H8.97a.75.75,0,0,0,0-1.5Z",
    transform: "translate(0 -0.85)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.98 4.618)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M181.9,111.865l-4.545-4.485a.747.747,0,1,0-1.049,1.064l3.248,3.205h-8.7a.748.748,0,0,0,0,1.5h8.7L176.3,116.35a.747.747,0,1,0,1.049,1.064l4.545-4.485a.747.747,0,0,0,0-1.064Z",
    transform: "translate(-170.1 -107.165)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitgroup);
export default __webpack_public_path__ + "static/media/exitgroup.13b02002c48519af18842f2d0f6b16f4.svg";
export { ForwardRef as ReactComponent };